import React, {useEffect, useState} from 'react';
import cx from 'clsx';
import s from './CartApp.scss';
import {useControllerProps} from '../../../../domain/controllers/ControllerContext';
import {withResizeObserver} from './HOC/withResizeObserver';
import {withSentryErrorBoundary} from '@wix/native-components-infra';
import {CART_DSN} from '@wix/ecom-platform-viewer-script/internal';
import './vars.scss';
import {ErrorToast} from '../../../../common/components/ErrorToast/ErrorToast';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {ToastPlacement} from '@wix/wix-ui-tpa';
import {SlotPlaceHolder} from '../../../../common/components/SlotPlaceHolder/SlotPlaceHolder';
import {SlotsMap} from '../../../../common/constants';
import {CartLayout} from './partials/CartLayout';
import {SPECS} from '../../../../domain/specs';

export enum CartAppDataHook {
  root = 'CartAppDataHook.root',
}

const CartApp = () => {
  const {isResponsive, isLoading, cartStore, cashierExpressStore} = useControllerProps();
  const viewerVersion = isResponsive ? 'viewer_x' : 'viewer_classic';
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const classNames = cx(s.main, s[viewerVersion], 'cart', {
    'cart-native-css-vars': experiments.enabled(SPECS.ecomCartNativeCssVars),
  });
  const [loaded, setLoaded] = useState(false);
  const shouldShowSkeleton = !loaded;
  useEffect(() => {
    setLoaded(!isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (loaded && !experiments.enabled(SPECS.RemovePmNameErrorModal)) {
      cashierExpressStore?.handlePaymentMethodError();
    }
  }, [loaded]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={s.container}>
      <main data-hook={CartAppDataHook.root} className={classNames} data-wix-cart tabIndex={-1}>
        {!shouldShowSkeleton && (
          <div className={!isMobile ? s.toastContainer : null}>
            <ErrorToast placement={isMobile ? ToastPlacement.bottomFullWidth : ToastPlacement.inline} />
          </div>
        )}
        <CartLayout shouldShowSkeleton={shouldShowSkeleton} />
        {!shouldShowSkeleton && cartStore?.AddSlotToCartPage && <SlotPlaceHolder slotId={SlotsMap.mainBottom} />}
      </main>
    </div>
  );
};

// eslint-disable-next-line import/no-default-export
export default withSentryErrorBoundary(withResizeObserver(CartApp), {
  dsn: CART_DSN,
  config: {environment: 'Native Component'},
});
